
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/passwort-vergessen",
      function () {
        return require("private-next-pages/passwort-vergessen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/passwort-vergessen"])
      });
    }
  